import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Home/Homepage.css";
import "./AllOpenOrdersPage.css";

const STATIC_OPEN_ORDERS = [
  { _id: "fo1", orderId: "FORD-7a2b3c4d", user_id: "user_101", pair_id: { short_name: "BTC/USDT" }, side: "LONG", type: "LIMIT", quantity: 0.05, price: 67500, filledQty: 0, feePaid: 0, status: "Open", createdAt: "2025-02-18T10:30:00.000Z" },
  { _id: "fo2", orderId: "FORD-8d3e4f5g", user_id: "user_202", pair_id: { short_name: "ETH/USDT" }, side: "SHORT", type: "LIMIT", quantity: 2, price: 3450, filledQty: 0, feePaid: 0, status: "Open", createdAt: "2025-02-18T09:15:00.000Z" },
  { _id: "fo3", orderId: "FORD-9e4f5g6h", user_id: "user_303", pair_id: { short_name: "SOL/USDT" }, side: "LONG", type: "MARKET", quantity: 50, price: null, filledQty: 0, feePaid: 0, status: "Open", createdAt: "2025-02-18T11:45:00.000Z" },
  { _id: "fo4", orderId: "FORD-1f5g6h7i", user_id: "user_101", pair_id: { short_name: "XRP/USDT" }, side: "SHORT", type: "LIMIT", quantity: 1000, price: 0.52, filledQty: 200, feePaid: 0.12, status: "Partial", createdAt: "2025-02-18T08:00:00.000Z" },
  { _id: "fo5", orderId: "FORD-2g6h7i8j", user_id: "user_404", pair_id: { short_name: "BTC/USDT" }, side: "LONG", type: "LIMIT", quantity: 0.1, price: 66000, filledQty: 0, feePaid: 0, status: "Open", createdAt: "2025-02-18T12:20:00.000Z" },
];

const FuturesOpenOrdersPage = () => {
  const [orders] = useState(STATIC_OPEN_ORDERS);
  const [search, setSearch] = useState("");
  const [loading] = useState(false);

  const formatDate = (iso) => {
    if (!iso) return "—";
    try {
      const d = new Date(iso);
      return d.toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return iso;
    }
  };

  const formatNum = (n) =>
    n != null && !Number.isNaN(Number(n))
      ? Number(n).toLocaleString("en-IN", { maximumFractionDigits: 10 })
      : "—";

  const filtered = orders.filter(
    (o) =>
      o.orderId?.toLowerCase().includes(search.toLowerCase()) ||
      o.user_id?.toLowerCase().includes(search.toLowerCase()) ||
      (o.pair_id?.short_name || o.symbol || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Futures Trading</span>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Futures Open Orders</span>
          </p>
          <h1 className="dashboard-hero__title">Futures Open Orders</h1>
          <p className="dashboard-hero__subtitle">
            View and manage all futures open orders across users
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-chart-line" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="openorders-section">
          <div className="openorders-section__header">
            <div className="openorders-section__title-wrap">
              <span className="openorders-section__icon">
                <i className="fas fa-clipboard-list" />
              </span>
              <h2 className="openorders-section__title">Futures Open Orders</h2>
            </div>
            <div className="openorders-section__stats">
              <span className="openorders-stat">
                <strong>{orders.length}</strong> Open
              </span>
            </div>
          </div>
          <div className="openorders-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by order ID, user ID or pair..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="openorders-search-input"
            />
          </div>
          {loading ? (
            <div className="openorders-empty">
              <i className="fas fa-spinner fa-spin" /> Loading…
            </div>
          ) : filtered.length > 0 ? (
            <div className="openorders-table-wrap">
              <table className="openorders-table">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>User ID</th>
                    <th>Pair</th>
                    <th>Side</th>
                    <th>Type</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Filled</th>
                    <th>Fee</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((row) => (
                    <tr key={row._id}>
                      <td><span className="openorders-order-id">{row.orderId ?? row._id}</span></td>
                      <td><span className="openorders-order-id">{row.user_id}</span></td>
                      <td><strong>{row.pair_id?.short_name || row.symbol || "—"}</strong></td>
                      <td>
                        <span className={`openorders-side openorders-side--${(row.side || "").toLowerCase()}`}>
                          {row.side ?? "—"}
                        </span>
                      </td>
                      <td>{row.type ?? "—"}</td>
                      <td>{formatNum(row.quantity)}</td>
                      <td>{row.price != null ? formatNum(row.price) : "Market"}</td>
                      <td>{formatNum(row.filledQty)}</td>
                      <td>{formatNum(row.feePaid)}</td>
                      <td>{row.status ?? "—"}</td>
                      <td>{formatDate(row.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="openorders-empty">
              {orders.length === 0
                ? "No futures open orders. Connect your admin API to fetch data."
                : "No orders match your search."}
            </p>
          )}
        </section>
      </div>
    </main>
  );
};

export default FuturesOpenOrdersPage;
